import React from 'react';
import styled from '@emotion/styled';
import Button from '@ordermygear/button';
import { OMGTheme } from '@ordermygear/theme';

const Tracker = styled.li`
  width: 31%;
  min-width: 225px;
  margin: 0.5%;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  background: #f1f1f1;
  border: 1px solid #BECAD6; 
  border-radius: 12px;
  padding: 5px; 
  @media only screen and (max-width: ${OMGTheme.breakpoints.md}) {
    width: 47%;
  }
  @media only screen and (max-width: ${OMGTheme.breakpoints.sm}) {
    width: 98%;
  }
`;

const TrackingInfo = styled.div`
  display: block;
  width: 100%;
  padding: 8px; 
`;

const TrackingImage  = styled.div`
  display: block;
  margin: 3px;
  height: 70px;
`;

const TrackingText  = styled.div`
  display: block;
  margin: 8px 0px;
  font-size: 0.8rem;
`;

interface OrderTrackerProps {
  carrier: string;
  code: string;
}

const OrderTracker: React.FC<OrderTrackerProps> = ({ carrier, code }) => {
  return (
    <Tracker>
      <TrackingImage>
        <img src={getCarrierLogo(carrier)} alt={carrier} />
      </TrackingImage>
      <TrackingInfo>
        <TrackingText>
          <b>{getCarrierName(carrier)}:</b> {code}
        </TrackingText>
        <a href={getTrackingURL(carrier, code)} style={{textDecoration: 'none'}}>
          <Button
            color="secondary"
            size="small"
          >
            Track
          </Button>
        </a>
      </TrackingInfo>
    </Tracker>
  );
};

const getTrackingURL = (carrier: string, code: string) => {
  switch (carrier) {
    case "usps":
      return "https://tools.usps.com/go/TrackConfirmAction.action?tLabels=" + code;
    case "ups":
      return "https://www.ups.com/track?loc=en_US&tracknum=" + code;
    case "fedex":
      return "https://www.fedex.com/fedextrack/?tracknumbers=" + code;
    case "canada_post":
      return "http://www.canadapost.ca/cpotools/apps/track/personal/findByTrackNumber?trackingNumber=" + code + "&LOCALE=en";
    case "purolator":
      return "https://www.purolator.com/purolator/ship-track/tracking-summary.page?pin=" + code;
    default:
      return "";
  }
};

const getCarrierLogo = (carrier: string) => {
  switch (carrier) {
    case "usps":
      return "https://assetly.ordermygear.com/images/w_70,h_70,c_limit/5af4a0518f167e542e8b4585.jpg";
    case "ups":
      return "https://assetly.ordermygear.com/images/w_70,h_70,c_limit/5af4a051ef4b30321f8b459a.jpg";
    case "fedex":
      return "https://assetly.ordermygear.com/images/w_70,h_70,c_limit/5af4a0515d1eb21c338b459b.jpg";
    case "canada_post":
      return "https://assetly.ordermygear.com/images/w_70,h_70,c_limit/5af4a050d7f9202d478b457c.jpg";
    case "purolator":
      return "https://assetly.ordermygear.com/images/w_70,h_70,c_limit/5af4a0510cc05be2388b4592.jpg";
    default:
      return "";
  }
};

const getCarrierName = (carrier: string) => {
  switch (carrier) {
    case "usps":
      return "USPS";
    case "ups":
      return "UPS";
    case "fedex":
      return "FedEx";
    case "canada_post":
      return "Canada Post";
    case "purolator":
      return "Purolator";
    default:
      return "";
  }
};

export default OrderTracker;